import { FormControl, Checkbox, Select, OutlinedInput, MenuItem, ListItemText, InputLabel, Stack, Radio, RadioGroup, FormControlLabel, DialogActions, Button, DialogContent, Typography, Tooltip } from "@mui/material"
import { APP_SOURCE, QUESTION_SOURCE_FLOW_KEY, QUESTION_SOURCE_KEY, QUESTION_SOURCE_SINGLE_KEY } from "../../../../constants/wizardConstants"
import { useEffect, useState } from "react"
import { BootstrapDialog, BootstrapDialogTitle } from "../../../utils/bootstrapDialog";

import HelpIcon from '@mui/icons-material/Help';
import { useContextAuth } from "../../../../authContext/AuthHook";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 7.5 + ITEM_PADDING_TOP,
            width: 310,
        },
    },
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "left"
    },
};

export const AppSourceValQuestion = ({ appSource, application, sourceFlow, answerQuestion, resetVal }) => {
    const { user } = useContextAuth();

    const [update, setUpdate] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [values, setValues] = useState([]);
    const [valueNames, setValueNames] = useState([]);

    const [openFlowModal, setOpenFlowModal] = useState(false);
    const [currentVal, setCurrentVal] = useState('');
    const handleOpenFlowModal = (item) => {
        setCurrentVal(item);
        setOpenFlowModal(true);
    }

    const handleChooseVariableFlow = () => {
        answerQuestion(QUESTION_SOURCE_FLOW_KEY, { ...sourceFlow, [currentVal]: 'variable' });
        setOpenFlowModal(false);
        setCurrentVal('');
    }

    const handleChooseConstantFlow = () => {
        answerQuestion(QUESTION_SOURCE_FLOW_KEY, { ...sourceFlow, [currentVal]: 'constant' });
        setOpenFlowModal(false);
        setCurrentVal('');
    }


    useEffect(() => {
        if (resetVal === true) {
            //console.log("Loaded: ", resetVal)
            setLoaded(false);
        }
    }, [resetVal]);

    useEffect(() => {
        if (loaded === false) {
            setLoaded(true);
            let localVal = [];
            let localValNames = [];

            Object.keys(appSource).forEach((key) => {
                let val = appSource[key];
                //console.log("Key: ", key, "Val: ", val)
                if (val === true) {
                    localVal.push(key);
                    localValNames.push(APP_SOURCE[key].label);
                }
            });

            setValues(localVal);
            setValueNames(localValNames);
        }
    }, [appSource, loaded]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;

        let localValuesNames = [];
        let valueIDs = [];
        if (value === 'string') {
            valueIDs = value.split(',');
        }
        else {
            //@ts-ignore
            valueIDs = value;
        }

        for (let index = 0; index < valueIDs.length; index++) {
            const sourceID = valueIDs[index];

            if (APP_SOURCE[sourceID] != null) {
                localValuesNames.push(APP_SOURCE[sourceID].label);
            }
        }


        setValues(
            typeof value === 'string' ? value.split(',') : value,
        );

        setValueNames(localValuesNames);
    };

    const handleChangeSingle = (event) => {
        const {
            target: { value },
        } = event;

        let localValuesNames = [];
        let valueIDs = [];

        if (value != null && value !== "") {
            valueIDs.push(value)
            localValuesNames.push(APP_SOURCE[value].label);
        }

        setValues(valueIDs);
        setValueNames(localValuesNames);
    };

    const handleChangeFlow = (itemKey, value) => {
        //console.log("Value: ", itemKey, value);
        //console.log("SourceFlow: ", sourceFlow)
        answerQuestion(QUESTION_SOURCE_FLOW_KEY, { ...sourceFlow, [itemKey]: value });
        setUpdate((val) => !val);
    }

    useEffect(() => {
        if (user?.isAnonymous === true || user?.isInternal !== true) {
            if (values.length === 1) {
                if (APP_SOURCE[values[0]]?.specifyFlow === true && sourceFlow?.[values[0]] == null) {
                    handleOpenFlowModal(values[0]);
                }
            }

            answerQuestion(QUESTION_SOURCE_SINGLE_KEY, values);
        }
        else {
            Object.keys(appSource).forEach((key) => {
                let val = appSource[key];

                if (values.indexOf(key) > -1) {
                    if (val !== true) {
                        //console.log("Set to true? ", key)
                        if (APP_SOURCE[key]?.specifyFlow === true && sourceFlow?.[key] == null) {
                            handleOpenFlowModal(key);
                        }
                        answerQuestion(QUESTION_SOURCE_KEY, key);
                    }
                }
                else {
                    if (val === true) {
                        //console.log("Set to not true? ", key)
                        answerQuestion(QUESTION_SOURCE_KEY, key);
                    }
                }
            });
        }

    }, [values])

    /**
     * 
     * @param {string[]} sourceNonCompatible 
     * @param {string[]} appNonCompatible 
     */
    const checkIfDisabled = (sourceNonCompatible, appNonCompatible) => {
        let disabled = false;

        if (appNonCompatible != null) {
            for (let index = 0; index < appNonCompatible.length; index++) {
                const appVal = appNonCompatible[index];

                if (application === appVal) {
                    disabled = true;
                    break;
                }
            }
        }


        if (disabled) return disabled;

        if (sourceNonCompatible != null) {
            for (let index = 0; index < sourceNonCompatible.length; index++) {
                const sourceVal = sourceNonCompatible[index];

                if (appSource[sourceVal] === true) {
                    disabled = true;
                    break;
                }
            }
        }

        return disabled;
    }

    const setListText = (source) => {
        if (values.length === 0 || checkIfDisabled(APP_SOURCE[source]?.nonCompatible, APP_SOURCE[source]?.appNonCompatible) || values.indexOf(source) > -1) {
            return APP_SOURCE[source]?.label;
        }
        else {
            return '+ ' + APP_SOURCE[source]?.label;
        }
    }

    const displayFlowOptions = () => {
        let selected = [];
        for (const key in appSource) {
            if (Object.hasOwnProperty.call(appSource, key)) {
                const element = appSource[key];

                if (element === true && APP_SOURCE[key]?.specifyFlow === true) {
                    selected.push(key);
                }
            }
        }

        return selected;
    }

    const toolTipComponent = (itemKey) => {
        return (
            <>
                <Typography gutterBottom textAlign={'center'} color="inherit">
                    Beroende på systemets uppbyggnad med t.ex. ackumulatortank kan både shuntgrupper med variabelt eller konstant flöde primärt vara aktuella.
                </Typography>

                <Typography gutterBottom textAlign={'center'} color="inherit">
                    Om ackumulatortank saknas eller är seriekopplad i systemet brukar konstant flöde vara lämpligast.
                </Typography>

                <Typography gutterBottom textAlign={'center'} color="inherit">
                    Om ackumulatortanken är kopplad så att det är en egen krets med konstant cirkulation mellan
                    värme-/kylkällan och ackumulatortanken väljs oftast shuntgrupper med variabelt flöde primärt.
                </Typography>
            </>
        )
    }

    return (
        <>
            <Stack direction={'row'} alignItems={'center'} spacing={3}>
                {user?.isAnonymous === true || user?.isInternal !== true ? (
                    <>
                        <FormControl>
                            <InputLabel>Källa</InputLabel>
                            <Select
                                sx={{ width: '180px', height: '30px', background: 'white' }}
                                size="small"
                                value={values}
                                onChange={handleChangeSingle}
                                input={<OutlinedInput label={'Källa'} />}
                                renderValue={() => valueNames.join(', ')}
                                MenuProps={MenuProps}
                            >
                                <MenuItem sx={{ height: '18px' }} value={''}></MenuItem>
                                {Object.keys(APP_SOURCE).map((source) => (
                                    <MenuItem key={APP_SOURCE[source].value} sx={{ height: '32px' }} value={APP_SOURCE[source].value}>
                                        <ListItemText primary={APP_SOURCE[source]?.label} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </>
                ) : (
                    <>
                        <FormControl>
                            <InputLabel>Källa</InputLabel>
                            <Select
                                sx={{ width: '180px', height: '30px', background: 'white' }}
                                size="small"
                                multiple
                                value={values}
                                onChange={handleChange}
                                input={<OutlinedInput label={'Källa'} />}
                                renderValue={() => valueNames.join(', ')}
                                MenuProps={MenuProps}
                            >
                                {Object.keys(APP_SOURCE).map((source) => (
                                    <MenuItem disabled={checkIfDisabled(APP_SOURCE[source]?.nonCompatible, APP_SOURCE[source]?.appNonCompatible)} key={APP_SOURCE[source].value} sx={{ height: '32px' }} value={APP_SOURCE[source].value}>
                                        <Checkbox checked={values.indexOf(source) > -1} />
                                        <ListItemText primary={setListText(source)} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </>
                )}

                {displayFlowOptions().length > 0 ? (
                    <Stack spacing={1} sx={{ paddingTop: '4px' }}>
                        {displayFlowOptions().map((itemKey) => {
                            return (
                                <FormControl key={itemKey}>
                                    <InputLabel shrink>Flöde primärt (källa {APP_SOURCE[itemKey]?.label})
                                        <Tooltip arrow placement="right-end" title={toolTipComponent(itemKey)}>
                                            <HelpIcon sx={{ color: '#5fabed', marginLeft: '3px' }} />
                                        </Tooltip>
                                    </InputLabel>
                                    <RadioGroup
                                        sx={{ marginTop: '5px', width: '200px' }}
                                        row
                                        value={sourceFlow?.[itemKey] || null}
                                        onChange={(event) => handleChangeFlow(itemKey, event.target.value)}
                                    >
                                        <FormControlLabel id={itemKey} value="constant" control={<Radio />} label="Konstant" />
                                        <FormControlLabel id={itemKey} value="variable" control={<Radio />} label="Variabelt" />
                                    </RadioGroup>
                                </FormControl>
                            )
                        })}
                    </Stack>
                ) : ("")}

            </Stack>

            <BootstrapDialog
                aria-labelledby="primary-flow-modal"
                open={openFlowModal}
            >
                <BootstrapDialogTitle>
                    Välj flöde primärt ({APP_SOURCE[currentVal]?.label})
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom textAlign={'center'}>
                        Beroende på systemets uppbyggnad med t.ex. ackumulatortank kan både shuntgrupper med variabelt eller konstant flöde primärt vara aktuella.
                    </Typography>
                    <Typography gutterBottom textAlign={'center'}>
                        Om ackumulatortank saknas eller är seriekopplad i systemet brukar konstant flöde vara lämpligast.
                    </Typography>
                    <Typography gutterBottom textAlign={'center'}>
                        Om ackumulatortanken är kopplad så att det är en egen krets med konstant cirkulation mellan
                        värme-/kylkällan och ackumulatortanken väljs oftast shuntgrupper med variabelt flöde primärt.
                    </Typography>
                    <Typography gutterBottom textAlign={'center'}>
                        Önskas konstant eller variabelt flöde primärt?
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', gap: 5 }}>
                    <Button sx={{ textTransform: 'none', width: '130px' }} variant="contained" onClick={handleChooseConstantFlow}>
                        Konstant
                    </Button>
                    <Button sx={{ textTransform: 'none', width: '130px' }} variant="contained" onClick={handleChooseVariableFlow}>
                        Variabelt
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </>
    )
}